import React from "react";
import Emblem from "@/components/Emblem";

export default function Loading({ label = "Standing by…" }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-[var(--rsp-bg)]">
      <div className="animate-pulse">
        <Emblem size={88} />
      </div>
      <p className="eyebrow" data-testid="loading-label">{label}</p>
    </div>
  );
}
